// src/components/LocationPermission.js
import React, { useState } from 'react';
import { httpsCallable } from 'firebase/functions';
import { agencyFunctions } from '../firebase'; // Ensure your functions instance is exported as agencyFunctions
import styles from '../styles/LocationPermission.module.css'; // We will create this CSS file

const LocationPermission = ({ onPermissionGiven }) => {
    const [isAsking, setIsAsking] = useState(false);
    const [error, setError] = useState('');

    const handleAllowClick = () => {
        setIsAsking(true);
        setError('');

        if (!navigator.geolocation) {
            setError("Geolocation is not supported by your browser.");
            setIsAsking(false);
            return;
        }

        navigator.geolocation.getCurrentPosition(
            // Success
            async (position) => {
                const { latitude, longitude } = position.coords;
                try {
                    // Call the same Cloud Function, but this time pass the coordinates
                    const recordLogin = httpsCallable(agencyFunctions, 'recordLoginActivity');
                    await recordLogin({ lat: latitude, lon: longitude });
                    
                    // Let the parent component know permission was handled
                    onPermissionGiven(true, "Location shared successfully!");

                } catch (err) {
                    console.error("Error sending coordinates to function:", err);
                    setError("Could not save location. Please try again.");
                    setIsAsking(false);
                }
            },
            // Error
            (err) => {
                console.warn(`Geolocation error: ${err.message}`);
                setError("Location access was denied or failed. You can change this in your browser settings.");
                setIsAsking(false);
                onPermissionGiven(false, "Location access was denied.");
            },
            { enableHighAccuracy: true, timeout: 15000, maximumAge: 0 }
        );
    };

    return (
        <div className={styles.permissionCard}>
            <h4>Improve Location Accuracy</h4>
            <p>For better security and reporting, please share your precise location. This is only recorded once per login.</p>
            {error && <p className={styles.errorMessage}>{error}</p>}
            <button onClick={handleAllowClick} disabled={isAsking} className={styles.allowButton}>
                {isAsking ? 'Getting Location...' : 'Share Precise Location'}
            </button>
        </div>
    );
};

export default LocationPermission;